export default __webpack_public_path__ + "static/media/SelectedLiveMachineIcon.d221bbc6.svg";